import { makeStyles } from '@surveycake/rc';
import { itemStyle } from '../styles';

export const useStyles = makeStyles([
  [
    'selectedItem',
	theme => `
		:lang(ar) div {
			transform: scaleX(-1);
			direction: rtl;
		}
		${itemStyle(theme)}
		display: flex;
		border-color ${theme.color.primary.default};
		color: ${theme.color.primary.default};
	`
  ],
  [
    'selecetedItemText',
	`	
		margin: 0 5px;
	`
  ],
  [
    'selectedItemRemove',
    theme => `
		display: inline-flex;
		align-items: center;
		align-self: flex-start;
		margin-left: auto;
		padding: 0.5em 10px;
		color: ${theme.color.primary.hover};

		&:hover {
			color: ${theme.color.primary.default};
		}
	`
  ],
  [
    'selectedItemDragging',
	(theme, deps, classes) => `
		background-color: ${theme.color.primary.hover};
		border-color: ${theme.color.primary.hover};
		color: ${theme.color.text.white};
		box-shadow: 1px 1px 4px 0px ${theme.color.primary.hover};
		-webkit-tap-highlight-color: transparent;

		& .${classes.selectedItemRemove} {
			color: ${theme.color.text.white}
		}
	`
	],
]);
